// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13WZN","col":"styles_col__1IzG4"};